import React from "react";
import {
  Card,
  CardContent,
  Divider,
  Grid,
  Box,
  FormControl,
  FormGroup,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

const CrmSkeltonDrawer = () => {
  return (
    <Card
      style={{
        width: "600px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
      }}
    >
      <CardContent>
        <div className="d-flex align-items-center justify-content-between">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="text" width={200} height={40} />
          </Box>
          {/* <Skeleton variant="circular" width={40} height={40} /> */}
        </div>

        <Divider style={{ margin: "8px 0" }} />

        {/* Editable Fields */}
        <Grid container sx={{ gap: "4px" }}>
          <Grid item xs={12}>
            <FormControl component="fieldset" fullWidth>
              <FormGroup>
                <Box display="flex" alignItems="center" mb={3}>
                  <RadioGroup>
                    <FormControlLabel
                      sx={{ "& .MuiFormControlLabel-label": { ml: 1 } }} // Adds 8px gap (adjust as needed)
                      control={
                        <Skeleton variant="circular" width={20} height={20} />
                      }
                      label={<Skeleton variant="text" width={120} />}
                    />
                  </RadioGroup>
                  <Skeleton variant="rectangular" width="100%" height={56} />
                </Box>

                <Box display="flex" alignItems="center" mb={3}>
                  <RadioGroup>
                    <FormControlLabel
                      sx={{ "& .MuiFormControlLabel-label": { ml: 1 } }} // Same gap here
                      control={
                        <Skeleton variant="circular" width={20} height={20} />
                      }
                      label={<Skeleton variant="text" width={120} />}
                    />
                  </RadioGroup>
                  <Skeleton variant="rectangular" width="100%" height={56} />
                </Box>

                <Box display="flex" alignItems="center" mb={3}>
                  <RadioGroup>
                    <FormControlLabel
                      sx={{ "& .MuiFormControlLabel-label": { ml: 1 } }} // And here
                      control={
                        <Skeleton variant="circular" width={20} height={20} />
                      }
                      label={<Skeleton variant="text" width={120} />}
                    />
                  </RadioGroup>
                  <Skeleton variant="rectangular" width="100%" height={56} />
                </Box>
              </FormGroup>
            </FormControl>

            <Box mt={2} mb={2}>
              <Skeleton variant="rectangular" width="100%" height={120} />
            </Box>

            <Grid
              container
              spacing={2}
              alignItems="center"
              style={{ marginBottom: 2, padding: 2 }}
            >
              <Grid item xs={6}>
                <Skeleton variant="rectangular" width="100%" height={56} />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="rectangular" width="100%" height={56} />
              </Grid>
            </Grid>

            <Box display="flex" alignItems="center" mt={2} mb={2}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={120} style={{ marginLeft: 8 }} />
            </Box>
            <Skeleton variant="rectangular" width="100%" height={56} />

            <Box mt={2} mb={2}>
              <Skeleton variant="text" width={120} />
              <Skeleton variant="rectangular" width="100%" height={56} />
            </Box>

            <Box mt={2} mb={2}>
              <Skeleton variant="text" width={120} />
              <Skeleton variant="rectangular" width="100%" height={56} />
            </Box>

            <Grid container mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Skeleton variant="text" width={160} />
                  <Skeleton variant="rectangular" width="100%" height={56} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Skeleton variant="text" width={160} />
                  <Skeleton variant="rectangular" width="100%" height={56} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Skeleton variant="text" width={160} />
                  <Skeleton variant="rectangular" width="100%" height={56} />
                </Grid>
              </Grid>
            </Grid>

            <Box mt={2} mb={2}>
              <Skeleton variant="text" width={120} />
              <Skeleton variant="rectangular" width="100%" height={56} />
            </Box>

            <Box mt={2} mb={2}>
              <Skeleton variant="text" width={120} />
              <Skeleton variant="rectangular" width="100%" height={56} />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CrmSkeltonDrawer;
